import { RhinoAssetType } from '../compat';

import { Asset } from './types';

type EpisodeLike = {
  episodeName?: string;
  episodeNumber?: number;
  seasonNumber?: number;
};

export function createTypeGuard<T extends Asset, R extends T>(...types: RhinoAssetType[]) {
  return function isAssetMatching(asset: T): asset is R {
    return types.includes(asset.type);
  };
}

export function getAssetEpisodeIndication<T extends EpisodeLike>(asset: T) {
  return {
    episodeName: asset.episodeName,
    episodeNumber: asset.episodeNumber,
    seasonNumber: asset.seasonNumber,
  };
}
